module.exports = __webpack_public_path__ + "img/bt.0c2f520c.png";